// extracted by mini-css-extract-plugin
export default {"pinBtnActiveInline":"HistoryDetailsPanel_pinBtnActiveInline__81agd"};